import './full-screen-loader.scss';
import { Spinner } from "../spinner/spinner";

export function FullScreenLoader() {
  return (
    <div className="FullScreenLoader">
      <Spinner></Spinner>
    </div>
  )
}